// A link target from stored data (a search hit's URL) may only open a web
// page: a poisoned datastore source carrying javascript:, data: or vbscript:
// would otherwise run on click, and Preact does not sanitise `href`.

/** The address when it is http or https, else "" (render the text inert). */
export function httpUrl(raw: string): string {
  try {
    const { protocol } = new URL(raw);
    return protocol === "http:" || protocol === "https:" ? raw : "";
  } catch {
    return "";
  }
}
